/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentControlExecuteRequest {
    getFixupPrototypeFunction() { return ComplianceAssessmentControlExecuteRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentControlExecuteRequest>): ComplianceAssessmentControlExecuteRequest {
        let obj = Object.assign(new ComplianceAssessmentControlExecuteRequest(), model);
        ComplianceAssessmentControlExecuteRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentControlExecuteRequest>): ComplianceAssessmentControlExecuteRequest {
        if (!model) return null;
        return ComplianceAssessmentControlExecuteRequest.newInstance(<ComplianceAssessmentControlExecuteRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentControlExecuteRequest) {
        if (!obj) return;

        models.ComplianceAssessmentControlExecuteRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentControlExecuteRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentControlExecuteRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

}
